import React from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Table, Spinner } from 'react-bootstrap';
import { SearchAlt } from '@styled-icons/boxicons-regular/SearchAlt';
import { CommentEdit } from '@styled-icons/boxicons-regular/CommentEdit';

//Components
import { campotexto } from '../../../../components/forms/campos/campos';


class ListaCadastro extends React.Component {

    componentDidMount(){
        //this.props.handleZeraPesquisa();
    }
    
    handleEditar = (item) => {
        this.props.cadastroselecionado(item);
        this.props.handleCloseModal();
        this.props.handleEditFormCad();
    }
    
    render() {        
        return (
            <Form
            onSubmit={this.props.handleSubmit}
            render={({ submitting, pristine, form, handleSubmit, submitSucceeded }) => (                
                <form onSubmit={handleSubmit}>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>{this.props.col0desc}</th>
                                <th>{this.props.col1desc}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={2}>
                                    <Field type="text" name={this.props.campopesquisa} component={campotexto} placeholder={this.props.placeholder} />
                                </td>                                
                                <td>
                                    <Button type="submit">
                                        <SearchAlt size="30" disabled={pristine || submitting} />
                                        {this.props.pendingTasks?
                                        <Spinner animation="border"  />
                                        :
                                        null
                                        }
                                    </Button>
                                </td>
                            </tr>
                        </tbody>
                    </Table>                    
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                            <th>{this.props.col0desc}</th>
                            <th>{this.props.col1desc}</th>
                            <th>{this.props.col2desc}</th>
                            <th>Editar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.cadastros.length?this.props.cadastros.map(itens => {
                                return (
                                    <tr key={itens[this.props.col0campo]}>
                                        <td>{itens[this.props.col0campo]}</td>
                                        <td>{itens[this.props.col1campo]}</td>
                                        <td>{itens[this.props.col2campo]}</td>
                                        <td>
                                            <CommentEdit style={{cursor: "pointer"}} onClick={() => this.handleEditar(itens)} size="35" />
                                        </td>
                                    </tr>  
                                )
                            })
                            :
                            null
                            }                  
                        </tbody>
                    </Table>
                </form>
            )}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks        
    }
}

export default connect(mapStateToProps)(withRouter(ListaCadastro));